import { useRef } from 'react';
import { DateHelpers } from '@headless-workspace/utils';

export function useAudioPlayer() {
    const audioRef = useRef<HTMLAudioElement | null>(null);
    const timeUpdateRef = useRef<(() => void) | null>(null);

    function waitForAudioDuration() {
        const originalDuration = document.querySelector('.ekoo-slidecontainer-duration') as HTMLElement;
        if (originalDuration) {
            originalDuration.style.display = 'none';
        }

        const container = document.querySelector('.ekoo-slidecontainer');
        const slider = document.querySelector('.ekoo-slidecontainer-range');

        const description = document.querySelector('.ekoo-informations-description');
        const mainText = document.querySelector('.ekoo-widget-container-text-main-content');

        if (description && mainText) {
            description.textContent = mainText.textContent;
        }

        if (container && slider) {
            const currentTimeEl = document.createElement('div');
            currentTimeEl.className = 'current-time';
            currentTimeEl.style.color = 'var(--text-tertiary)';
            currentTimeEl.style.fontSize = '14px';
            currentTimeEl.style.marginRight = '8px';
            currentTimeEl.textContent = '00:00'; // Initial value

            const totalTimeEl = document.createElement('div');
            totalTimeEl.className = 'total-time';
            totalTimeEl.style.color = 'var(--text-tertiary)';
            totalTimeEl.style.fontSize = '14px';
            totalTimeEl.style.marginLeft = '8px';

            container.insertBefore(currentTimeEl, slider);
            container.insertBefore(totalTimeEl, slider.nextSibling);

            const audio = document.querySelector('audio');
            audioRef.current = audio;

            if (audio) {
                totalTimeEl.textContent = DateHelpers.formatTimeDuration(audio.duration);
                timeUpdateRef.current = () => {
                    currentTimeEl.textContent = DateHelpers.formatTimeDuration(audio.currentTime);
                };
                audio.addEventListener('timeupdate', timeUpdateRef.current);
            }
        }
    }

    return {
        waitForAudioDuration,
        audioRef,
        timeUpdateRef,
    };
}
